export const heroTagline = 'Snowflake optimization & cost management platform'
export const heroDescription =
  'Gain visibility into Snowflake usage, optimize performance and automate savings with the click of a button.'
export const isProd = process.env.NEXT_PUBLIC_SELECT_ENV == 'prod'
export const isStaging = process.env.NEXT_PUBLIC_SELECT_ENV == 'staging'
export const isDev = !isProd && !isStaging
export const selectEnv = process.env.NEXT_PUBLIC_SELECT_ENV
export const apiBaseUrl = process.env.NEXT_PUBLIC_BACKEND_API_BASE_URL
export const googleAnalyticsGTag = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_GTAG
export const corporationName = 'Select Labs Inc.'
export const slackClientId = process.env.NEXT_PUBLIC_SLACK_CLIENT_ID
export const loginLink = '/app'
// https://mailtolink.me/
export const supportLink =
  'mailto:support@select.dev?subject=SELECT%20Support%20Request&body=Hello%2C%0D%0A%0D%0A%3Cplease%20describe%20your%20issue%2C%20including%20any%20relevant%20details%20and%20screenshots%20to%20help%20our%20team%20diagnose%20your%20issue%3E%0D%0A%0D%0ACompany%20Name%3A%20%3Cyour%20company%20name%3E%0D%0A'
export const dbtSnowflakeMonitoringLink = '/docs/dbt-snowflake-monitoring'
export const changelogConvertKitFormId = '4925976'
export const blogConvertKitFormId = '3548599'
export const meetingLink = 'https://calendly.com/ian-at-select/30min'
export const statusPage = 'https://select-dot-dev.instatus.com/'

export const signupLink = '/signup'
export const bookDemoLink = 'https://calendly.com/ian-at-select/demo-with-ian-from-select' // '/demo'
export const getStartedLink = '/get-started'

// Image rendered in URL link previews by default
export const mainLinkPreviewImage =
  'https://select.dev/cdn-cgi/imagedelivery/1zmOcgV1p520E4lLTrYjjg/1d6a0203-8895-4d53-d57a-09e78286b200/public'
